import { Component, OnInit, Input } from '@angular/core';
import { QuestionImageAndMedia } from 'src/app/common-class/questions';

@Component({
  selector: 'app-question-image-and-media',
  templateUrl: './question-image-and-media.component.html',
  styleUrls: ['./question-image-and-media.component.css'],
})
export class QuestionImageAndMediaComponent implements OnInit {
  @Input() questionImageAndMedias: QuestionImageAndMedia[];
  @Input() imageSize: number = 0;
  @Input() isMobile: boolean;
  imagesArray: any;
  constructor() {}
  ngOnInit() {
    if (!this.isMobile) {
      let imageArray = [];
      if (this.imageSize == 0 && this.questionImageAndMedias.length == 1) {
        imageArray.push(this.questionImageAndMedias);
      } else {
        this.questionImageAndMedias.sort((n1, n2) => n1.RowPosition - n2.RowPosition);
        let unique = this.questionImageAndMedias
          .map((e) => e.RowPosition)
          .filter((value, index, self) => self.indexOf(value) === index);
        if (unique.length > 0) {
          if (unique[0] == 0) {
            for (const questionImageAndMedia of this.questionImageAndMedias) {
              let newImages = [];
              for (let j = 1; j <= 3; j++) {
                if (j == questionImageAndMedia.HPosition) {
                  newImages.push(questionImageAndMedia);
                } else {
                  if (this.imageSize != 0) {
                    newImages.push({ ColPosition: j, Caption: 'BlankImage' });
                  }
                }
              }
              imageArray.push(newImages);
            }
          } else {
            for (const uniqueItem of unique) {
              const images = this.questionImageAndMedias.filter((e) => e.RowPosition == uniqueItem);
              const newImages = [];
              for (let j = 1; j <= 3; j++) {
                  const col = images.find((e) => e.ColPosition == j);

                if (col != undefined && col != null) {
                  newImages.push(col);
                } else {
                  if (this.imageSize != 0) {
                    newImages.push({ ColPosition: j, Caption: 'BlankImage' });
                  }
                }
              }
              imageArray.push(newImages);
            }
          }
        }
      }

      this.imagesArray = imageArray;
    } else {
      this.questionImageAndMedias.sort((n1, n2) => n2.RowPosition - n1.RowPosition);
    }
  }
}
